import {
  ReactNode,
  createContext,
  useState,
  useCallback,
  useMemo,
} from 'react';

const noop = () => null;

export interface InterfaceTopAdBarContext {
  showTopAdBar: () => void;
  hideTopAdBar: () => void;
  isShowTopAdBar: boolean;
  height: number;
  setHeight: (height: number) => void;
}

interface TopAdBarProviderProps {
  children: ReactNode;
}

export const TopAdBarContext = createContext<InterfaceTopAdBarContext>({
  showTopAdBar: noop,
  hideTopAdBar: noop,
  isShowTopAdBar: true,
  height: 0,
  setHeight: noop,
});

function TopAdBarProvider({ children }: Readonly<TopAdBarProviderProps>) {
  const [isShowTopAdBar, setIsShowTopAdBar] = useState(true);
  const [height, setHeight] = useState(0);

  const showTopAdBar = useCallback(() => setIsShowTopAdBar(true), []);
  const hideTopAdBar = useCallback(() => setIsShowTopAdBar(false), []);

  const value = useMemo(
    () => ({
      isShowTopAdBar,
      showTopAdBar,
      hideTopAdBar,
      height,
      setHeight,
    }),
    [isShowTopAdBar, showTopAdBar, hideTopAdBar, height, setHeight],
  );

  return (
    <TopAdBarContext.Provider value={value}>
      {children}
    </TopAdBarContext.Provider>
  );
}

export default TopAdBarProvider;
